import { useState } from 'react';
import { sendSupportMessage } from '../utils/api';
import { C } from '../utils/constants';

export const SupportModal = ({ onClose }) => {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!message.trim()) return;
    setSending(true);
    setError('');
    try {
      await sendSupportMessage(message);
      setSent(true);
    } catch (e) {
      setError('Something went wrong. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: 16,
      }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: '#fff', borderRadius: 16, padding: '32px 28px',
        width: '100%', maxWidth: 480,
        boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
        animation: 'fadeInUp 0.3s ease both',
      }}>
        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: 16 }}>✅</div>
            <h2 style={{
              fontFamily: "'Forum', serif", color: C.brown,
              fontSize: '1.4rem', marginBottom: 12,
            }}>
              Message Sent!
            </h2>
            <p style={{ color: C.terracotta, fontSize: '0.95rem', marginBottom: 24 }}>
              Ben will get back to you as soon as possible.
            </p>
            <button className="btn-primary" onClick={onClose} style={{ width: '100%' }}>
              Close
            </button>
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
              <div>
                <h2 style={{
                  fontFamily: "'Forum', serif", color: C.brown,
                  fontSize: '1.4rem', marginBottom: 4,
                }}>
                  Get in Touch
                </h2>
                <p style={{ color: C.terracotta, fontSize: '0.88rem' }}>
                  Questions, feedback, or need help? Ben will reply directly.
                </p>
              </div>
              <button
                onClick={onClose}
                style={{
                  background: 'rgba(0,0,0,0.06)', border: 'none', borderRadius: '50%',
                  width: 32, height: 32, cursor: 'pointer', fontSize: '1rem',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0, marginLeft: 12,
                }}
              >
                ✕
              </button>
            </div>

            <textarea
              value={message}
              onChange={e => setMessage(e.target.value)}
              placeholder="Write your message here..."
              rows={6}
              style={{
                width: '100%', borderRadius: 10, border: `1.5px solid ${C.border}`,
                padding: '12px 14px', fontSize: '0.95rem', fontFamily: "'Nunito', sans-serif",
                color: C.text, resize: 'vertical', outline: 'none',
                boxSizing: 'border-box', lineHeight: 1.6,
              }}
              onFocus={e => e.target.style.borderColor = C.gold}
              onBlur={e => e.target.style.borderColor = C.border}
            />

            {error && (
              <p style={{ color: '#e53e3e', fontSize: '0.85rem', marginTop: 8 }}>{error}</p>
            )}

            <button
              className="btn-primary"
              onClick={handleSubmit}
              disabled={sending || !message.trim()}
              style={{ width: '100%', marginTop: 16 }}
            >
              {sending ? 'Sending...' : 'Send Message →'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
